var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notifications.length)?_c('div',{staticClass:"push-notifications"},_vm._l((_vm.notifications),function(notification){return _c('PushNotification',{key:notification.id,staticClass:"push-notifications__item",attrs:{"item":notification}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }